<form [formGroup]="componentForm">
	<div class="row mb-3" [attr.data-test-id]="'dobFormGroup'">
		<label class="col-md-3 col-lg-4 col-form-label required">DOB</label>
		<div class="col-md-9 col-lg-8">
			<ejs-datepicker placeholder="mm/dd/yyyy"
							[format]="dateFormat"
							formControlName="dob">
			</ejs-datepicker>
		</div>
	</div>
	<div *pmsUsaOnly class="row mb-3" [attr.data-test-id]="'ssnFormGroup'">
		<label class="col-md-3 col-lg-4 col-form-label">SSN</label>
		<div class="col-md-9 col-lg-8">
		<pms-social-security-number-input
			[last4Ssn]="patientResponse?.last4ssn"
			[fullSsnAvailable]="patientResponse?.fullSsnAvailable"
			[last4SsnControl]="this.componentForm.get('last4Ssn')"
			[ssnControl]="this.componentForm.get('ssn')"
			[disabled]="controlContainer.control.disabled"
			[patientId]="patientId">
		</pms-social-security-number-input>
		</div>
	</div>
	<div *pmsCanadaOnly class="row mb-3">
		<label class="col-md-3 col-lg-4 col-form-label">SIN/PHN</label>
		<div class="col-md-9 col-lg-8">
			<input pmsSinInput class="e-input" type="text" formControlName="sin"/>
		</div>
	</div>
	@if (displayAlternateId) {
		<div [attr.data-test-id]="'alternateIdFormGroup'" class="row mb-3">
			<label class="col-md-3 col-lg-4 col-form-label">Alternate ID</label>
			<div class="col-md-9 col-lg-8">
				<input class="e-input" type="text" formControlName="alternateId"/>
			</div>
		</div>
	}
	<div class="row mb-3" [attr.data-test-id]="'guarantorFormGroup'">
		<label class="col-md-3 col-lg-4 col-form-label">Guarantor</label>
		@if (isNewPatient) {
		<div class="col-md-9 col-lg-8">
			<p class="form-control-static">Self</p>
		</div>
		} @else {
			<div class="col-md-9 col-lg-8">
				@if (guarantorOptions) {
					<ejs-dropdownlist
						formControlName="guarantorId"
						[dataSource]="guarantorOptions">
					</ejs-dropdownlist>
				}
			</div>
		}
	</div>
	<div class="row mb-3" [attr.data-test-id]="'sexFormGroup'">
		<label class="col-md-3 col-lg-4 col-form-label required">Sex</label>
		<div class="col-md-9 col-lg-8">
			<pms-enum-select-button
				[enumList]="genderOptions"
				[allOption]="false"
				formControlName="gender">
			</pms-enum-select-button>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'sexualOrientationFormGroup'">
		<label class="col-md-3 col-lg-4 col-form-label">Sexual Orientation</label>
		<div class="col-md-9 col-lg-8">
			<pms-constant-dropdown
				[constantList]="sexualOrientationOptions"
				[showClearButton]="true"
				placeholder="Select Sexual Orientation"
				formControlName="sexualOrientation">
			</pms-constant-dropdown>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'genderIdentityFormGroup'">
		<label class="col-md-3 col-lg-4 col-form-label">Gender Identity</label>
		<div class="col-md-9 col-lg-8">
			<pms-constant-dropdown
				[constantList]="genderIdentityOptions"
				[showClearButton]="true"
				placeholder="Select Gender Identity"
				formControlName="genderIdentity">
			</pms-constant-dropdown>
		</div>
	</div>
	@if (preferredPronounFeatureFlag) {
		<div class="row mb-3" [attr.data-test-id]="'preferredPronounFormGroup'">
			<label class="col-md-3 col-lg-4 col-form-label">Preferred Pronoun</label>
			<div class="col-md-9 col-lg-8">
				@if (preferredPronounOptions) {
					<ejs-dropdownlist [dataSource]="preferredPronounOptions"
									  placeholder="Select Preferred Pronoun"
									  [showClearButton]="true"
									  formControlName="preferredPronounId">
					</ejs-dropdownlist>
				}
			</div>
		</div>
	}
	<div class="row mb-3" [attr.data-test-id]="'statusFormGroup'">
		<label class="col-md-3 col-lg-4 col-form-label">Status</label>
		<div class="col-md-9 col-lg-8">
			<pms-enum-select-button
				[enumList]="statusOptions"
				[allOption]="false"
				formControlName="establishedStatus">
			</pms-enum-select-button>
		</div>
	</div>
		<div class="row mb-3" [attr.data-test-id]="'spokenLanguageFormGroup'">
		<label class="col-12 col-md-3 col-lg-4 col-form-label" [class.required]="isSpokenLanguageRequired">Spoken Language</label>
		<div class="col-7 col-md-5 col-lg-5">
			@if (languageOptions) {
				<ejs-dropdownlist [dataSource]="languageOptions"
								  placeholder="Select Spoken Language"
								  [showClearButton]="true"
								  formControlName="spokenLanguageId">
				</ejs-dropdownlist>
			}
		</div>
		<div class="col-5 col-md-4 col-lg-3">
			<ejs-checkbox label="Declined" formControlName="spokenLanguageDeclined">
			</ejs-checkbox>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'writtenLanguageFormGroup'">
		<label class="col-12 col-md-3 col-lg-4 col-form-label" [class.required]="isWrittenLanguageRequired">Written Language</label>
		<div class="col-7 col-md-5 col-lg-5">
			@if (languageOptions) {
				<ejs-dropdownlist [dataSource]="languageOptions"
								  placeholder="Select Written Language"
								  [showClearButton]="true"
								  formControlName="writtenLanguageId">
				</ejs-dropdownlist>
			}
		</div>
		<div class="col-5 col-md-4 col-lg-3">
			<ejs-checkbox label="Declined" formControlName="writtenLanguageDeclined">
			</ejs-checkbox>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'interpreterFormGroup'">
		<label class="col-md-3 col-lg-4 col-form-label" [class.required]="isInterpreterRequired">Interpreter</label>
		<div class="col-md-9 col-lg-8">
			<pms-enum-select-button
				[enumList]="interpreterOptions"
				[allOption]="false"
				formControlName="interpreterAssistance">
			</pms-enum-select-button>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'racesFormGroup'">
		<label class="col-12 col-md-3 col-lg-4 col-form-label" [class.required]="isRaceRequired">Races</label>
		<div class="col-7 col-md-5 col-lg-5">
			@if (raceOptions) {
				<ejs-multiselect
					[dataSource]="raceOptions"
					[showDropDownIcon]="true"
					formControlName="raceIds"
					showSelectAll="true"
					filterBarPlaceholder="Search"
					placeholder="Select Races"
					mode="CheckBox"
					[fields]="{text: 'label', value: 'value'}">
				</ejs-multiselect>
			}
		</div>
		<div class="col-5 col-md-4 col-lg-3">
			<ejs-checkbox label="Declined" formControlName="raceDeclined">
			</ejs-checkbox>
		</div>
	</div>
	<div class="row mb-3" [attr.data-test-id]="'ethnicityFormGroup'">
		<label class="col-12 col-md-3 col-lg-4 col-form-label"
			   [class.required]="isEthnicityRequired">Ethnicity</label>
		<div class="col-7 col-md-5 col-lg-5">
			@if (ethnicityOptions) {
				<ejs-multiselect
					[dataSource]="ethnicityOptions"
					[showDropDownIcon]="true"
					formControlName="ethnicityIds"
					showSelectAll="true"
					filterBarPlaceholder="Search"
					placeholder="Select Ethnicities"
					mode="CheckBox"
					[fields]="{text: 'label', value: 'value'}">
				</ejs-multiselect>
			}
		</div>
		<div class="col-5 col-md-4 col-lg-3">
			<ejs-checkbox label="Declined" formControlName="ethnicityDeclined">
			</ejs-checkbox>
		</div>
	</div>
	@if (tribalAffiliationFeatureFlag) {
		<div class="row mb-3" [attr.data-test-id]="'tribalAffiliationFormGroup'">
			<label class="col-12 col-md-3 col-lg-4 col-form-label">Tribal Affiliation</label>
			<div class="col-7 col-md-5 col-lg-5">
				@if (tribalAffiliationOptions) {
					<ejs-dropdownlist [dataSource]="tribalAffiliationOptions"
									  placeholder="Select Tribal Affiliation"
									  [showClearButton]="true"
									  formControlName="tribalAffiliationId">
					</ejs-dropdownlist>
				}
			</div>
			<div class="col-5 col-md-4 col-lg-3">
				<ejs-checkbox label="Declined" formControlName="tribalAffiliationDeclined">
				</ejs-checkbox>
			</div>
		</div>
	}
	@if (patientResponse?.dod) {
		<div class="row mb-3">
			<label class="col-12 col-md-3 col-lg-4 col-form-label">DOD</label>
			<div class="col-7 col-md-5 col-lg-5">
				<p class="form-control-static">{{ patientResponse?.dod | date: dateFormat }}</p>
			</div>
		</div>
	}
</form>
